import axios from "axios";
import instance from "./BasebMarketing";
import params from "../configs/params";

export function getMarketingOptInPage(organisationId) {
  return instance.get(`opt-in-page/?organisation_id=${organisationId}`, {
    withCredentials: false,
  });
}

export function updateMarketingOptInPage(organisationId, data) {
  return instance.patch("opt-in-page/", {
    organisation_id: organisationId,
    ...data,
  }, {
    withCredentials: false,
  });
}

export function getPublicMarketingOptInPage(pageId) {
  return instance.get(`public/opt-in/${pageId}/`, { withCredentials: false });
}

export function submitPublicMarketingOptIn(pageId, data) {
  return instance.post(`public/opt-in/${pageId}/`, data, { withCredentials: false });
}

export function getEmailTemplates(organisationId) {
  return instance.request({
    url: `email-templates/?organisation_id=${organisationId}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function createEmailTemplate(data) {
  // Check if data contains files (FormData) or is regular JSON
  const hasFiles = data instanceof FormData;
  
  if (hasFiles) {
    // For FormData, use axios directly to avoid any instance transformations
    const accessToken = localStorage.getItem("accessToken");
    return axios.post(`${params.bMarketingUrl}email-templates/`, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: accessToken ? `Bearer ${accessToken}` : undefined,
      },
    });
  }
  
  return instance.request({
    url: `email-templates/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function updateEmailTemplate(templateId, data) {
  // Check if data contains files (FormData) or is regular JSON
  const hasFiles = data instanceof FormData;
  
  if (hasFiles) {
    // For FormData, use axios directly to avoid any instance transformations
    const accessToken = localStorage.getItem("accessToken");
    return axios.patch(`${params.bMarketingUrl}email-templates/${templateId}/`, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: accessToken ? `Bearer ${accessToken}` : undefined,
      },
    });
  }
  
  return instance.request({
    url: `email-templates/${templateId}/`,
    method: "PATCH",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function deleteEmailTemplate(templateId) {
  return instance.request({
    url: `email-templates/${templateId}/`,
    method: "DELETE",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function duplicateEmailTemplate(templateId, data = {}) {
  return instance.request({
    url: `email-templates/${templateId}/duplicate/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function getEmailTemplateDetails(templateId) {
  return instance.request({
    url: `email-templates/${templateId}/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function sendTestEmail(templateId, email, senderDomainId = null) {
  const data = { email };
  if (senderDomainId) {
    data.sender_domain_id = senderDomainId;
  }
  return instance.request({
    url: `email-templates/${templateId}/send-test/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function verifyPublicEmailPreferences(userId, token) {
  return axios.get(`${params.bMarketingUrl}public/email-preferences/`, {
    params: {
      user_id: userId,
      token,
    },
    withCredentials: false,
    headers: {
      Accept: "application/json",
    },
  });
}

export function updatePublicEmailPreferences(data) {
  return axios.patch(`${params.bMarketingUrl}public/email-preferences/`, data, {
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getPublicEmailBrowserContent(templateId, recipient, token) {
  return axios.get(`${params.bMarketingUrl}public/email-browser/`, {
    params: {
      template_id: templateId,
      recipient,
      token,
    },
    withCredentials: false,
    headers: {
      Accept: "application/json",
    },
  });
}

export function importEmailTemplate(data) {
  // Import must use FormData with ZIP file
  const accessToken = localStorage.getItem("accessToken");
  return axios.post(`${params.bMarketingUrl}email-templates/import/`, data, {
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: accessToken ? `Bearer ${accessToken}` : undefined,
    },
  });
}

// Sender Domains API

export function getMarketingSenderDomains(organisationId) {
  return instance.request({
    url: `sender-domains/?organisation_id=${organisationId}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function createMarketingSenderDomain(data) {
  return instance.request({
    url: "sender-domains/",
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function updateMarketingSenderDomain(senderDomainId, data) {
  return instance.request({
    url: `sender-domains/${senderDomainId}/`,
    method: "PATCH",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function verifyMarketingSenderDomain(senderDomainId) {
  return instance.request({
    url: `sender-domains/${senderDomainId}/verify/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function deleteMarketingSenderDomain(senderDomainId) {
  return instance.request({
    url: `sender-domains/${senderDomainId}/`,
    method: "DELETE",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getSmsTemplates(organisationId) {
  return instance.request({
    url: `sms-templates/?organisation_id=${organisationId}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getSmsCompliance(organisationId) {
  return instance.request({
    url: `sms-compliance/?organisation_id=${organisationId}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function submitSmsCompliance(data) {
  return instance.request({
    url: "sms-compliance/",
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function createSmsTemplate(data) {
  const hasFiles = data instanceof FormData;

  if (hasFiles) {
    const accessToken = localStorage.getItem("accessToken");
    return axios.post(`${params.bMarketingUrl}sms-templates/`, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: accessToken ? `Bearer ${accessToken}` : undefined,
      },
    });
  }

  return instance.request({
    url: "sms-templates/",
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function updateSmsTemplate(templateId, data) {
  const hasFiles = data instanceof FormData;

  if (hasFiles) {
    const accessToken = localStorage.getItem("accessToken");
    return axios.patch(`${params.bMarketingUrl}sms-templates/${templateId}/`, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: accessToken ? `Bearer ${accessToken}` : undefined,
      },
    });
  }

  return instance.request({
    url: `sms-templates/${templateId}/`,
    method: "PATCH",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function deleteSmsTemplate(templateId) {
  return instance.request({
    url: `sms-templates/${templateId}/`,
    method: "DELETE",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function sendTestSmsTemplate(templateId, data) {
  return instance.request({
    url: `sms-templates/${templateId}/send-test/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function getWhatsappTemplates(organisationId) {
  return instance.request({
    url: `whatsapp-templates/?organisation_id=${organisationId}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function createWhatsappTemplate(data) {
  const hasFiles = data instanceof FormData;

  if (hasFiles) {
    const accessToken = localStorage.getItem("accessToken");
    return axios.post(`${params.bMarketingUrl}whatsapp-templates/`, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: accessToken ? `Bearer ${accessToken}` : undefined,
      },
    });
  }

  return instance.request({
    url: "whatsapp-templates/",
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function updateWhatsappTemplate(templateId, data) {
  const hasFiles = data instanceof FormData;

  if (hasFiles) {
    const accessToken = localStorage.getItem("accessToken");
    return axios.patch(`${params.bMarketingUrl}whatsapp-templates/${templateId}/`, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: accessToken ? `Bearer ${accessToken}` : undefined,
      },
    });
  }

  return instance.request({
    url: `whatsapp-templates/${templateId}/`,
    method: "PATCH",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function deleteWhatsappTemplate(templateId) {
  return instance.request({
    url: `whatsapp-templates/${templateId}/`,
    method: "DELETE",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function submitWhatsappTemplateForReview(templateId, data) {
  const hasFiles = data instanceof FormData;

  if (hasFiles) {
    const accessToken = localStorage.getItem("accessToken");
    return axios.post(`${params.bMarketingUrl}whatsapp-templates/${templateId}/submit-review/`, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: accessToken ? `Bearer ${accessToken}` : undefined,
      },
    });
  }

  return instance.request({
    url: `whatsapp-templates/${templateId}/submit-review/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function refreshWhatsappTemplateStatus(templateId) {
  return instance.request({
    url: `whatsapp-templates/${templateId}/refresh-status/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function sendTestWhatsappTemplate(templateId, data) {
  return instance.request({
    url: `whatsapp-templates/${templateId}/send-test/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function getWhatsappCredentialsStatus(organisationId) {
  return instance.request({
    url: `whatsapp-credentials/status/?organisation_id=${organisationId}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getWhatsappCredentialAccounts(organisationId) {
  return instance.request({
    url: `whatsapp-credentials/accounts/?organisation_id=${organisationId}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function validateWhatsappCredentialAccount(data) {
  return instance.request({
    url: "whatsapp-credentials/validate/",
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function saveWhatsappCredentialAccounts(data) {
  return instance.request({
    url: "whatsapp-credentials/accounts/",
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function deleteWhatsappCredentialAccount({ organisation_id, account_id }) {
  return instance.request({
    url: `whatsapp-credentials/accounts/${account_id}/?organisation_id=${organisation_id}`,
    method: "DELETE",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getWhatsappAccountPhoneNumbers(organisationId, accountId) {
  return instance.request({
    url: `whatsapp-credentials/accounts/${accountId}/phone-numbers/?organisation_id=${organisationId}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function refreshWhatsappMessagingLimits(organisationId) {
  return instance.request({
    url: "whatsapp-credentials/messaging-limits/refresh/",
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: {
      organisation_id: organisationId,
    },
  });
}

export function deactivateWhatsappCredentials(data) {
  return instance.request({
    url: "whatsapp-credentials/deactivate/",
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

// Automations API

export function getAutomations(organisationId, type = null) {
  let url = `automations/?organisation_id=${organisationId}`;
  if (type && type !== 'all') {
    url += `&type=${type}`;
  }
  return instance.request({
    url: url,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getAutomation(automationId) {
  return instance.request({
    url: `automations/${automationId}/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function createAutomation(data) {
  return instance.request({
    url: `automations/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function updateAutomation(automationId, data) {
  return instance.request({
    url: `automations/${automationId}/`,
    method: "PATCH",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function deleteAutomation(automationId) {
  return instance.request({
    url: `automations/${automationId}/`,
    method: "DELETE",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getAutomationTargetLocations(automationId) {
  return instance.request({
    url: `automations/${automationId}/target-locations/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

// Campaigns API

export function getCampaigns(organisationId, filters = {}) {
  return instance.request({
    url: "campaigns/",
    method: "GET",
    withCredentials: false,
    params: {
      organisation_id: organisationId,
      page: filters.page || 1,
      page_size: filters.pageSize || 25,
      ...(filters.campaignType ? { campaign_type: filters.campaignType } : {}),
    },
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function createCampaign(data) {
  return instance.request({
    url: "campaigns/",
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function updateCampaign(campaignId, data) {
  return instance.request({
    url: `campaigns/${campaignId}/`,
    method: "PATCH",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function runCampaignAction(campaignId, action) {
  return instance.request({
    url: `campaigns/${campaignId}/action/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: { action },
  });
}

export function estimateCampaignAudience(data) {
  return instance.request({
    url: "campaigns/audience-estimate/",
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function deleteCampaign(campaignId) {
  return instance.request({
    url: `campaigns/${campaignId}/`,
    method: "DELETE",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

// Email Activity Logs API

export function getEmailActivityLogs(organisationId, filters = {}) {
  let url = `activity-logs/?organisation_id=${organisationId}`;
  
  if (filters.channel) {
    url += `&channel=${filters.channel}`;
  }
  if (filters.event) {
    url += `&event=${filters.event}`;
  }
  if (filters.location_id) {
    url += `&location_id=${filters.location_id}`;
  }
  if (filters.template_id) {
    url += `&template_id=${filters.template_id}`;
  }
  if (filters.recipient_email) {
    url += `&recipient_email=${encodeURIComponent(filters.recipient_email)}`;
  }
  if (filters.contact_id) {
    url += `&contact_id=${encodeURIComponent(filters.contact_id)}`;
  }
  if (filters.is_test !== undefined && filters.is_test !== "" && filters.is_test !== "all") {
    url += `&is_test=${encodeURIComponent(filters.is_test)}`;
  }
  if (filters.page) {
    url += `&page=${filters.page}`;
  }
  if (filters.page_size) {
    url += `&page_size=${filters.page_size}`;
  }
  
  return instance.request({
    url: url,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getEmailActivityStats(organisationId, rangeDays = 30, filters = {}) {
  let url = `activity-logs/stats/?organisation_id=${organisationId}&range_days=${rangeDays}`;

  if (filters.channel) {
    url += `&channel=${filters.channel}`;
  }
  if (filters.section) {
    url += `&section=${encodeURIComponent(filters.section)}`;
  }
  if (filters.metric) {
    url += `&metric=${encodeURIComponent(filters.metric)}`;
  }
  if (filters.campaign_id) {
    url += `&campaign_id=${encodeURIComponent(filters.campaign_id)}`;
  }

  return instance.request({
    url: url,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getEmailMarketingUsage(organisationId) {
  return instance.request({
    url: `usage/?organisation_id=${organisationId}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function updateEmailMarketingUsageLimit(organisationId, usageLimit) {
  return instance.request({
    url: "usage/",
    method: "PATCH",
    data: {
      organisation_id: organisationId,
      usage_limit: usageLimit,
    },
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getWhatsappAnalytics(organisationId) {
  return instance.request({
    url: `whatsapp-analytics/?organisation_id=${organisationId}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

// Contacts / Audience API

export function getContacts(organisationId, filters = {}) {
  let url = `contacts/?organisation_id=${organisationId}`;

  if (filters.location_id) {
    url += `&location_id=${filters.location_id}`;
  }
  if (filters.tag_id) {
    url += `&tag_id=${filters.tag_id}`;
  }
  if (filters.source) {
    url += `&source=${filters.source}`;
  }
  if (filters.email_marketing !== undefined && filters.email_marketing !== "") {
    url += `&email_marketing=${filters.email_marketing}`;
  }
  if (filters.sms_marketing !== undefined && filters.sms_marketing !== "") {
    url += `&sms_marketing=${filters.sms_marketing}`;
  }
  if (filters.whatsapp_marketing !== undefined && filters.whatsapp_marketing !== "") {
    url += `&whatsapp_marketing=${filters.whatsapp_marketing}`;
  }
  if (filters.email_validation_status) {
    url += `&email_validation_status=${encodeURIComponent(filters.email_validation_status)}`;
  }
  if (filters.search) {
    url += `&search=${encodeURIComponent(filters.search)}`;
  }
  if (filters.page) {
    url += `&page=${filters.page}`;
  }
  if (filters.page_size) {
    url += `&page_size=${filters.page_size}`;
  }

  return instance.request({
    url,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getContactDetail(contactId) {
  return instance.request({
    url: `contacts/${contactId}/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function createContact(data) {
  return instance.request({
    url: "contacts/",
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function importContactsCsv({ organisationId, source, file, defaultLocationId, emailMarketingStatus }) {
  const formData = new FormData();
  formData.append("organisation_id", organisationId);
  formData.append("source", source);
  formData.append("file", file);
  formData.append("email_marketing_status", emailMarketingStatus || "unknown");
  if (defaultLocationId && defaultLocationId !== "none") {
    formData.append("default_location_id", defaultLocationId);
  }

  return instance.request({
    url: "contacts/imports/",
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
    },
    data: formData,
  });
}

export function getContactImport(importId) {
  return instance.request({
    url: `contacts/imports/${importId}/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getContactImports(organisationId) {
  return instance.request({
    url: `contacts/imports/?organisation_id=${organisationId}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function updateContact(contactId, data) {
  return instance.request({
    url: `contacts/${contactId}/`,
    method: "PATCH",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function deleteContact(contactId) {
  return instance.request({
    url: `contacts/${contactId}/`,
    method: "DELETE",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getContactsStats(organisationId) {
  return instance.request({
    url: `contacts/stats/?organisation_id=${organisationId}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getEmailSuppressions(organisationId, filters = {}) {
  const query = new URLSearchParams({
    organisation_id: organisationId,
    active: filters.active || "true",
    page: String(filters.page || 1),
    page_size: String(filters.page_size || 25),
  });
  if (filters.reason) query.set("reason", filters.reason);
  if (filters.search) query.set("search", filters.search);

  return instance.request({
    url: `contacts/email-suppressions/?${query.toString()}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function clearEmailSuppression(suppressionId, data) {
  return instance.request({
    url: `contacts/email-suppressions/${suppressionId}/clear/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

// ── Contact Tags API ────────────────────────────────────────────────────

export function getContactTags(organisationId) {
  return instance.request({
    url: `contacts/tags/?organisation_id=${organisationId}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function createContactTag(data) {
  return instance.request({
    url: "contacts/tags/",
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function updateContactTag(tagId, data) {
  return instance.request({
    url: `contacts/tags/${tagId}/`,
    method: "PATCH",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function deleteContactTag(tagId) {
  return instance.request({
    url: `contacts/tags/${tagId}/`,
    method: "DELETE",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

// ── Segments API ─────────────────────────────────────────────────────────────

export function getSegments(organisationId) {
  return instance.request({
    url: `segments/?organisation_id=${organisationId}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getSegment(segmentId) {
  return instance.request({
    url: `segments/${segmentId}/`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function createSegment(data) {
  return instance.request({
    url: `segments/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function updateSegment(segmentId, data) {
  return instance.request({
    url: `segments/${segmentId}/`,
    method: "PATCH",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function deleteSegment(segmentId) {
  return instance.request({
    url: `segments/${segmentId}/`,
    method: "DELETE",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function getSegmentContacts(segmentId, filters = {}) {
  let url = `segments/${segmentId}/contacts/?`;
  if (filters.search) {
    url += `&search=${encodeURIComponent(filters.search)}`;
  }
  if (filters.page) {
    url += `&page=${filters.page}`;
  }
  if (filters.page_size) {
    url += `&page_size=${filters.page_size}`;
  }
  return instance.request({
    url,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function refreshSegmentCount(segmentId) {
  return instance.request({
    url: `segments/${segmentId}/refresh-count/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}
